import { Box } from "@chakra-ui/react";
import React from "react";

const DashboardLayout: React.FC = ({ children }) => {
    return (
        <Box width="100%" height="calc(100vh - 0px)" position="relative">
            { children }
        </Box>
    );
};

export default DashboardLayout;
